import { Component, OnInit, Input, ElementRef, ViewChild, EventEmitter } from '@angular/core'
import { EnrollmentDetail } from '../models/en-details'
import { EappBeneficiaryGateway } from '../gateways/EAppEnrollment-gateway'
import { EnrollmentViewModel } from '../models/enrollment-view-model'
import { FormValidationService } from '../../validations/form-validation-service'
import { ValidatedSelectOptionModel } from '../../validations/validated-dropdown.component'
import { ValidatedRadioButtonModel } from '../../validations/validated-radio-button-group.component'
import { NotBlankGenericFieldValidator } from '../../validations/not-blank-generic-field-validator'
import { DateTextFieldValidator } from '../../validations/date-text-field.validator'
import { EmailAddressTextFieldValidator } from '../../validations/email-address-text-field-validator'
import { UserAccessGateway } from '../../common/gateways/user-access-gateway'
import { SubmitEnrollmentDataResponse } from '../models/submit-enrollment-data-response'
import { ActivatedRoute, Params } from '@angular/router'
import { Router } from '@angular/router'
import { PortalGlobals } from '../../portalglobals'
import { EnrollmentFieldBeneficiary, EnrollmentFieldCodesBeneficiary } from '../models/enrollment-field-beneficiary'
import * as moment from 'moment'
import { BeneficiaryElectionPeriods } from '../models/beneficiary-election-periods'
import { EnrollmentElectionType } from '../models/enrollment-election-type'
import { RelationshipToEnrollee } from '../models/relationshipToEnrollee'
import { UtilsService } from '../../enrollment/components/common/utils-service'
import { EnrollmentField, EnrollmentFieldCodes } from '../models/enrollment-field'

@Component({
    selector: 'EAppVerifyStep3',
    templateUrl: 'e-app-verify-Step3.component.html',
    styleUrls: ['./EApp-beneficiary.component.scss']
})
export class EAppVerifyStep3Component implements OnInit {
    get address(): EnrollmentDetail {
        return this.enrollmentDetail
    }
    enrollmentDetail: EnrollmentDetail = {} as EnrollmentDetail
    enrollmentViewModel: EnrollmentViewModel = {} as EnrollmentViewModel
    selectedElectionTypes: EnrollmentElectionType[] = [] as EnrollmentElectionType[]
    enrollmentElectionTypes: EnrollmentElectionType[] = [] as EnrollmentElectionType[]
    isValidAgent: boolean
    orgID: number
    planYear2018: boolean
    showUpdatesSettingsMessage = 'Success'
    hasError: boolean
    ErrorMessages: any[] = []
    id: string
    isAuthRep: boolean
    finalsubmit: boolean = false
    hideAgree: boolean = true
    disabled: boolean
    public loading: boolean = false
    public disableSubmitBtn: boolean = false
    notBlankValidator = new NotBlankGenericFieldValidator()
    validatedDate = new DateTextFieldValidator()
    emailValidator = new EmailAddressTextFieldValidator()
    rblRelation: ValidatedSelectOptionModel[] = []
    public rblAppointmentRep: ValidatedRadioButtonModel[] = []
    public rblAuthorizedRep: ValidatedRadioButtonModel[] = []
    public rblMailCopy: ValidatedRadioButtonModel[] = []
    states: ValidatedSelectOptionModel[]
    public insurance: string
    onValueChange: EventEmitter<EnrollmentViewModel> = new EventEmitter<EnrollmentViewModel>()
    reasonCode = '-1'
    orgName: string
    private uniqueLink: string

    @Input() enrollmentindvrepViewModel: EnrollmentViewModel
    public rblReltoEnroll: ValidatedSelectOptionModel[] = []
    visibleFrom2025: boolean
    isAppInd: boolean
    public rblAppIndIND: ValidatedRadioButtonModel[] = []
    public relationshipToEnrolleeList: RelationshipToEnrollee[] = [] as RelationshipToEnrollee[]

    @ViewChild('focusableEleTop', { static: true }) focusableEleTop: ElementRef
    constructor(
        private _enrollmentGateway: EappBeneficiaryGateway,
        private route: ActivatedRoute,
        private router: Router,
        private utils: UtilsService,
        protected formValidationService: FormValidationService,
        private _userAccessGateway: UserAccessGateway,
        private _global: PortalGlobals
    ) {}

    ngOnInit() {
        this.focusableEleTop.nativeElement.focus()
        //this.insurance = this._global.currentUser.insuranceCompanyName
        this.hasError = false
        this.isAuthRep = false
        this.getParams()
        this.disabled = true
        if (this.id === '3') {
            this.finalsubmit = true
        }
        this.enrollmentViewModel = this._enrollmentGateway.getEnrollmentViewModel()
        this.route.params.forEach((params: Params) => {
            this.uniqueLink = this.route.snapshot.params['guid']
        })
        this.enrollmentViewModel = this._enrollmentGateway.getEnrollmentViewModel()
        if (
            this.enrollmentViewModel === undefined ||
            this.enrollmentViewModel === null ||
            this.enrollmentViewModel.UNIQUELINK === undefined ||
            this.enrollmentViewModel.UNIQUELINK === ''
        ) {
            this.enrollmentViewModel.UNIQUELINK = this.uniqueLink
            this.setData()
        }
        if (this.enrollmentViewModel.PLANYEAR != undefined && this.enrollmentViewModel.PLANYEAR != '') {
            this.setOrgname(this.enrollmentViewModel.PLANYEAR)
        }
        this.enrollmentViewModel.BENEFICIARYSIGN = ''
        this.enrollmentViewModel.BENEFICIARYDATE = moment().format('MM/DD/YYYY')

        //this.enrollmentDetail.Email = this.enrollmentViewModel.APPEMAIL

        this.isAuthRep = false
        this.getParams()
        this.rblRelation.push(
            { value: 'Aunt', text: 'Aunt' },
            { value: 'Brother', text: 'Brother' },
            { value: 'Caretaker', text: 'Caretaker' },
            { value: 'Case Worker', text: 'Case Worker' },
            { value: 'Companion', text: 'Companion' },
            { value: 'Cousin', text: 'Cousin' },
            { value: 'Daughter', text: 'Daughter' },
            { value: 'Daughter In Law', text: 'Daughter In Law' },
            { value: 'Father', text: 'Father' },
            { value: 'Father In Law', text: 'Father In Law' },
            { value: 'Friend', text: 'Friend' },
            { value: 'Grand Daughter', text: 'Grand Daughter' },
            { value: 'Grand Son', text: 'Grand Son' },
            { value: 'Home Provider', text: 'Home Provider' },
            { value: 'Hospice', text: 'Hospice' },
            { value: 'Husband', text: 'Husband' },
            { value: 'Mother In Law', text: 'Mother In Law' },
            { value: 'Mother', text: 'Mother' },
            { value: 'Nephew', text: 'Nephew' },
            { value: 'Niece', text: 'Niece' },
            { value: 'Power of Attorney', text: 'Power of Attorney' },
            { value: 'Program Coordinator', text: 'Program Coordinator' },
            { value: 'Other', text: 'Other' },
            { value: 'Residential Support', text: 'Residential Support' },
            { value: 'Son In Law', text: 'Son In Law' },
            { value: 'Sister', text: 'Sister' },
            { value: 'Son', text: 'Son' },
            { value: 'Social Worker', text: 'Social Worker' },
            { value: 'Step Daughter', text: 'Step Daughter' },
            { value: 'Step Son', text: 'Step Son' },
            { value: 'Wife', text: 'Wife' },
            { value: 'Spouse', text: 'Spouse' }
        )

        this.rblAppointmentRep.push(
            {
                value: 'Yes',
                htmlLabel: 'I completed a Scope of Appointment and I will submit it separately.',
                disabled: this.disabled
            },
            {
                value: 'No',
                htmlLabel:
                    'A Scope of Appointment was NOT completed because I did not ' +
                    'have an individual or one-on-one marketing appointment (whether in person, telephonically or otherwise) ' +
                    'with the applicant.',
                disabled: this.disabled
            }
        )
        this.rblAuthorizedRep.push(
            {
                value: 'No',
                htmlLabel: 'No'
            },
            {
                value: 'Yes',
                htmlLabel: 'Yes'
            }
        )
        this.rblMailCopy.push({ value: 'B', htmlLabel: 'Yes' }, { value: '', htmlLabel: 'No' })
        this._enrollmentGateway
            .GetAllStatesForBeneficiary(this.enrollmentViewModel.INSURANCECOMPID)
            .subscribe((states: ValidatedSelectOptionModel[]) => (this.states = states))

        this.getbackData()
        this.clearebackData()

        this.visibleFrom2025 = Number(this.enrollmentViewModel.PLANYEAR) > this._global.Planyear2024
        this.isAppInd = !!(this.enrollmentViewModel.INDREPIND && this.enrollmentViewModel.INDREPIND == 'Yes')
        this.rblAppIndIND.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })

        this._enrollmentGateway.getRelationshipToEnrolleeDataForBeneficiary().subscribe((model: RelationshipToEnrollee[]) => {
            this.relationshipToEnrolleeList = model

            this.relationshipToEnrolleeList.forEach((element, index) => {
                this.rblReltoEnroll.push({ value: element.RelationshipToEnrolleeCode, text: element.RelationshipToEnrolleeValue })
            })

            this.relToEnrollonValueChange(this.enrollmentViewModel.RELTOENROLL)
        })
    }

    valueChanged(bAgree: boolean) {
        this.enrollmentViewModel.BGCHECK = bAgree
        this.onValueChange.emit(this.enrollmentViewModel)
    }

    rblAuthorizedRepClick(event: any): void {
        if (event === 'Yes') {
            this.isAuthRep = true
        } else {
            this.isAuthRep = false
        }
        this.enrollmentViewModel.AUTHREPIND = event
    }

    isFormInvalid(): boolean {
        this.hasError = false
        this.ErrorMessages = []

        if (this.enrollmentViewModel.INDREPIND === 'Yes') {
            if (
                this.enrollmentViewModel.INDREPNAME === undefined ||
                this.enrollmentViewModel.INDREPNAME === null ||
                this.enrollmentViewModel.INDREPNAME == ''
            ) {
                this.ErrorMessages.push('Individual Rep Name is required')
                this.hasError = true
            }
            if (
                this.enrollmentViewModel.RELTOENROLL === undefined ||
                this.enrollmentViewModel.RELTOENROLL === null ||
                this.enrollmentViewModel.RELTOENROLL == ''
            ) {
                this.ErrorMessages.push('Relationship to enrollee is required')
                this.hasError = true
            }
            if (
                (this.enrollmentViewModel.displayRELTOENROLL == 'Agent' || this.enrollmentViewModel.displayRELTOENROLL == 'Broker') &&
                (this.enrollmentViewModel.NPN === undefined || this.enrollmentViewModel.NPN === null || this.enrollmentViewModel.NPN == '')
            ) {
                this.ErrorMessages.push('National Producer Number is required')
                this.hasError = true
            }

            if (this.enrollmentViewModel.NPN != undefined && this.enrollmentViewModel.NPN != null && this.enrollmentViewModel.NPN != '') {
                if (!this.utils.isValidNPN(this.enrollmentViewModel.NPN)) {
                    this.hasError = true
                    this.ErrorMessages.push('Invalid NPN')
                }
            }
        }
        if (
            this.enrollmentViewModel.BENEFICIARYSIGN === undefined ||
            this.enrollmentViewModel.BENEFICIARYSIGN === null ||
            this.enrollmentViewModel.BENEFICIARYSIGN === ''
        ) {
            this.ErrorMessages.push("Enter Beneficiary's Signature")
            this.hasError = true
        }
        if (
            this.enrollmentViewModel.AUTHREPIND === undefined ||
            this.enrollmentViewModel.AUTHREPIND === null ||
            this.enrollmentViewModel.AUTHREPIND === ''
        ) {
            this.ErrorMessages.push('Authorized Representative is required')
            this.hasError = true
        }

        if (this.enrollmentViewModel.AUTHREPIND === 'Yes') {
            if (this.enrollmentViewModel.AUTHREPNAME === undefined || this.enrollmentViewModel.AUTHREPNAME === '') {
                this.ErrorMessages.push('Enter Authorized Representative Name')
                this.hasError = true
            } else {
                let checkFName = this.enrollmentViewModel.AUTHREPNAME,
                    regexFNameVal = new RegExp("^[a-zA-Z.' ]*$")
                let isFnameValid = regexFNameVal.test(checkFName)
                if (!isFnameValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Authorized Representative Name is invalid')
                }
            }
            if (this.enrollmentViewModel.AUTHREPPHONE === undefined || this.enrollmentViewModel.AUTHREPPHONE === '') {
                this.ErrorMessages.push('Authorized Representative Phone is required')
                this.hasError = true
            } else {
                let checkOrgPhone = this.enrollmentViewModel.AUTHREPPHONE.replace(/-/g, '')
                if (/^\d{10}$/.test(checkOrgPhone)) {
                } else {
                    if (!this.isValidNumber(checkOrgPhone)) {
                        this.ErrorMessages.push('Authorized Representative Phone cannot contain letters or special characters.')
                        this.hasError = true
                    } else {
                        this.ErrorMessages.push('Authorized Representative Phone must be exactly 10 numbers.')
                        this.hasError = true
                    }
                }
            }
            if (this.enrollmentViewModel.AUTHREPREL === undefined || this.enrollmentViewModel.AUTHREPREL === '') {
                this.ErrorMessages.push('Select Representative Relation')
                this.hasError = true
            }
            if (this.enrollmentViewModel.AUTHREPST === undefined || this.enrollmentViewModel.AUTHREPST === '') {
                this.ErrorMessages.push('Select Authorized Representative State')
                this.hasError = true
            }
            if (this.enrollmentViewModel.AUTHREPADD1 === undefined || this.enrollmentViewModel.AUTHREPADD1 === '') {
                this.ErrorMessages.push('Enter Authorized Representative Address')
                this.hasError = true
            }
            if (this.enrollmentViewModel.AUTHREPCITY === undefined || this.enrollmentViewModel.AUTHREPCITY === '') {
                this.ErrorMessages.push('Enter Authorized Representative City')
                this.hasError = true
            } else {
                let regexCityVal = /^[A-Za-z\s\-.]+$/
                let isCityValid = regexCityVal.test(this.enrollmentViewModel.AUTHREPCITY)
                if (!isCityValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Please enter valid Authorized Representative City')
                }
            }
            if (this.enrollmentViewModel.AUTHREPZIP === undefined || this.enrollmentViewModel.AUTHREPZIP === '') {
                this.ErrorMessages.push('Enter Authorized Representative Zip')
                this.hasError = true
            } else {
                let checkZipCode = this.enrollmentViewModel.AUTHREPZIP,
                    regexVal = new RegExp('[0-9]{5}')
                let isZipCodeValid = regexVal.test(checkZipCode)
                if (!isZipCodeValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Authorized Representative Zip is invalid')
                }
            }
        }

        return this.hasError
    }

    private isValidNumber(text: string): boolean {
        return /^\d*$/.test(text)
    }

    onAgreeChange(enrollmentDetail): void {
        this.enrollmentDetail = enrollmentDetail
        this.isValidAgent = this.enrollmentViewModel.BGCHECK
        console.log(this.enrollmentDetail.Email)
    }

    getParams() {
        this.route.params.forEach((params: Params) => {
            this.uniqueLink = this.route.snapshot.params['guid']
            this.id = this.route.snapshot.params['id']
        })
    }

    setbackData() {
        localStorage.setItem('eappVerify3INDREPIND', this.enrollmentViewModel.INDREPIND)

        if (this.enrollmentViewModel.INDREPIND === 'Yes') {
            localStorage.setItem('eappVerify3INDREPNAME', this.enrollmentViewModel.INDREPNAME)
            localStorage.setItem('eappVerify3NPN', this.enrollmentViewModel.NPN)
            localStorage.setItem('eappVerify3RELTOENROLL', this.enrollmentViewModel.RELTOENROLL)
            localStorage.setItem('eappVerify3displayRELTOENROLL', this.enrollmentViewModel.displayRELTOENROLL)
        } else {
            this.enrollmentViewModel.INDREPNAME = ''
            this.enrollmentViewModel.NPN = ''
            this.enrollmentViewModel.RELTOENROLL = ''
            this.enrollmentViewModel.displayRELTOENROLL = ''
        }
    }
    getbackData() {
        if (localStorage.getItem('eappVerify3INDREPNAME') != null) {
            this.enrollmentViewModel.INDREPNAME = localStorage.getItem('eappVerify3INDREPNAME') || ''
        }
        if (localStorage.getItem('eappVerify3NPN') != null) {
            this.enrollmentViewModel.NPN = localStorage.getItem('eappVerify3NPN') || ''
        }
        if (localStorage.getItem('eappVerify3RELTOENROLL') != null) {
            this.enrollmentViewModel.RELTOENROLL = localStorage.getItem('eappVerify3RELTOENROLL') || ''
        }
        if (localStorage.getItem('eappVerify3INDREPIND') != null) {
            this.enrollmentViewModel.INDREPIND = localStorage.getItem('eappVerify3INDREPIND') || ''
        }
        if (localStorage.getItem('eappVerify3displayRELTOENROLL') != null) {
            this.enrollmentViewModel.displayRELTOENROLL = localStorage.getItem('eappVerify3displayRELTOENROLL') || ''
        }
    }
    clearebackData() {
        localStorage.removeItem('eappVerify3INDREPNAME')
        localStorage.removeItem('eappVerify3NPN')
        localStorage.removeItem('eappVerify3RELTOENROLL')
        localStorage.removeItem('eappVerify3INDREPIND')
        localStorage.removeItem('eappVerify3displayRELTOENROLL')
    }

    btnBack() {
        //Remove Data from the Individual
        if (!(this.enrollmentViewModel.INDREPIND === 'Yes')) {
            this.selectedNo(this.enrollmentViewModel)
        }

        this.setbackData()
        this.enrollmentViewModel = this._enrollmentGateway.getEnrollmentViewModel()
        this.router.navigate(['/Step2/' + this.enrollmentViewModel.UNIQUELINK])
    }

    btnPrevious() {
        this.enrollmentViewModel = this._enrollmentGateway.getEnrollmentViewModel()
        this.router.navigate(['/Step2/' + this.enrollmentViewModel.UNIQUELINK])
    }

    selectedNo(enrollObject: EnrollmentViewModel) {
        if (enrollObject == null) {
            this.enrollmentindvrepViewModel.RELTOENROLL = ''
            this.enrollmentindvrepViewModel.displayRELTOENROLL = ''
            this.enrollmentindvrepViewModel.NPN = ''
            this.enrollmentindvrepViewModel.INDREPNAME = ''
        } else {
            enrollObject.RELTOENROLL = ''
            enrollObject.displayRELTOENROLL = ''
            enrollObject.NPN = ''
            enrollObject.INDREPNAME = ''
        }
    }

    onSubmitmyApp() {
        this.hasError = false

        if (this.isFormInvalid()) {
            this.hasError = true
            this.focusableEleTop.nativeElement.focus()
        } else {
            this.disableSubmitBtn = true
            let ElectiontypeID = this.enrollmentViewModel.SEPREASONCD
            this.enrollmentViewModel.SEPREASONCD = this.enrollmentViewModel.SELREASONCODE

            //Remove Data from the Individual
            if (!(this.enrollmentViewModel.INDREPIND === 'Yes')) {
                this.selectedNo(this.enrollmentViewModel)
            }

            this.enrollmentViewModel.SUBMISSIONTYPECODE = 'COMPLETE'
            // this.router.navigate(['enrollment/e-application/messages/' + "5"])
            //this.router.navigate(['enrollment/e-application/messages/5'])
            this.enrollmentViewModel.DEX = 'AGNTP'
            this.enrollmentViewModel.AGENTDEX = 'EENRL'

            this.resetAutorize()
            this.loading = true
            this._enrollmentGateway.SubmitEnrollmentData(this.enrollmentViewModel).subscribe(
                (model: SubmitEnrollmentDataResponse) => {
                    let response = model
                    if (response !== undefined) {
                        if (response.Errors !== undefined && response.Errors.length > 0) {
                            this.hasError = false

                            for (let i = 0; i < response.Errors.length; i++) {
                                this.ErrorMessages.push(response.Errors[i].ErrorMessage)
                            }
                            this.hasError = true
                            this.disableSubmitBtn = false
                            this.loading = false
                            this.enrollmentViewModel.SEPREASONCD = ElectiontypeID
                            this.focusableEleTop.nativeElement.focus()
                        } else {
                            if (
                                response.confirmationNumber !== undefined &&
                                response.confirmationNumber !== null &&
                                response.confirmationNumber !== ''
                            ) {
                                this.enrollmentViewModel.CONF = response.confirmationNumber
                                //this._enrollmentGateway.setEnrollmentViewModel(this.enrollmentViewModel)
                                //this._enrollmentGateway.SendEappEmailOnConfirmation(this.enrollmentViewModel.PLANNAME).subscribe(() => this.showUpdatesSettingsMessage = 'Success')
                                this.enrollmentViewModel.AppStatus = 'Signed'
                                this._enrollmentGateway.setEnrollmentViewModel(this.enrollmentViewModel)
                                this.loading = false
                                //this.loading = true
                                this.router.navigate(['/messages/5/' + this.enrollmentViewModel.INSURANCECOMPID])

                                //this._enrollmentGateway.UpdateElectronicEnrollmentData(this.enrollmentViewModel)
                                //    .subscribe(
                                //    (model: SubmitEnrollmentDataResponse) => {
                                //        let response = model
                                //        if (response !== undefined) {
                                //            if (response.Errors !== undefined && response.Errors.length > 0) {
                                //                this.hasError = false

                                //                for (let i = 0; i < response.Errors.length; i++) {
                                //                    this.ErrorMessages.push(response.Errors[i].ErrorMessage)
                                //                }
                                //                this.hasError = true
                                //                this.disableSubmitBtn = false
                                //                this.loading = false
                                //                this.focusableEleTop.nativeElement.focus()
                                //            }
                                //            else {
                                //                this._enrollmentGateway.setEnrollmentViewModel(this.enrollmentViewModel)
                                //                this.disableSubmitBtn = false
                                //                this.loading = false
                                //                this.router.navigate(['/messages/5/' + this.enrollmentViewModel.INSURANCECOMPID])
                                //                // this.router.navigate(['enrollment/e-application/messages/' + "1"])
                                //            }
                                //        }
                                //        else {
                                //            this.ErrorMessages.push('Error while submitting data, please try again.')
                                //            this.hasError = true
                                //            this.disableSubmitBtn = false
                                //            this.loading = false
                                //            this.focusableEleTop.nativeElement.focus()
                                //        }
                                //    })
                            }
                            // this.router.navigate(['enrollment/e-application/messages/5'])
                        }
                    } else {
                        this.enrollmentViewModel.SEPREASONCD = ElectiontypeID
                        this.router.navigate(['/messages/5/' + this.enrollmentViewModel.INSURANCECOMPID])
                        this.ErrorMessages.push('Error while submitting data, please try again.')
                        this.hasError = true
                        this.disableSubmitBtn = false
                        this.loading = false
                        this.focusableEleTop.nativeElement.focus()
                    }
                    // this.loading = false
                },
                (err) => {
                    this.disableSubmitBtn = false
                    this.loading = false
                }
            )
        }
    }

    rejectStep() {
        if (this.enrollmentViewModel.UNIQUELINK !== null && this.enrollmentViewModel.UNIQUELINK !== undefined) {
            this.router.navigate([
                '/confirmation/' + this.enrollmentViewModel.UNIQUELINK + '/' + '2' + '/' + this.enrollmentViewModel.INSURANCECOMPID
            ])
        }
    }
    onKeyDown(event) {
        const ENTER_KEY = 13
        if (event.keyCode === ENTER_KEY) {
            this.onSubmitmyApp()
        }
    }
    setData() {
        if (this.enrollmentViewModel.UNIQUELINK !== null && this.enrollmentViewModel.UNIQUELINK !== undefined) {
            this.loading = true
            this._enrollmentGateway.getEnrollmentAppDetails(this.enrollmentViewModel.UNIQUELINK).subscribe(
                (model: EnrollmentFieldBeneficiary[]) => {
                    for (let i = 0; i < model.length; i++) {
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.ETHNICITY) {
                            this.enrollmentViewModel.Ethnicity = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.RACE) {
                            this.enrollmentViewModel.Race = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.ACCHOLDERNAME) {
                            this.enrollmentViewModel.ACCHOLDERNAME = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.ELECTION) {
                            this.enrollmentViewModel.ELECTION = model[i].FieldValue
                            if (this.enrollmentViewModel.ELECTION !== undefined) {
                            }
                            //this.periodSelected = model[i].FieldValue
                        }
                        //delete
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.RELCD) {
                            this.enrollmentViewModel.RELCD = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.AGENTFN) {
                            this.enrollmentViewModel.AGENTFN = model[i].FieldValue
                        }

                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.AGENTLN) {
                            this.enrollmentViewModel.AGENTLN = model[i].FieldValue
                        }

                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.AgentSignature) {
                            this.enrollmentViewModel.AgentSignature = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.PLANTYPE) {
                            this.enrollmentViewModel.PLANTYPE = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.APPDT) {
                            this.enrollmentViewModel.APPDT = moment(model[i].FieldValue).format('MM/DD/YYYY')
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.EFFDT) {
                            this.enrollmentViewModel.EFFDT = moment(model[i].FieldValue).format('MM/DD/YYYY')
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.APPFN) {
                            this.enrollmentViewModel.APPFN = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.APPLN) {
                            this.enrollmentViewModel.APPLN = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.SUFFIX) {
                            this.enrollmentViewModel.SUFFIX = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.APPMI) {
                            this.enrollmentViewModel.APPMI = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.TITLE) {
                            this.enrollmentViewModel.TITLE = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.HICN) {
                            this.enrollmentViewModel.HICN = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.MEDA) {
                            if (model[i].FieldValue !== undefined && model[i].FieldValue !== '') {
                                this.enrollmentViewModel.MEDA = moment(model[i].FieldValue).format('MM/DD/YYYY')
                            } else {
                                this.enrollmentViewModel.MEDA = null
                            }
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.MEDB) {
                            if (model[i].FieldValue !== undefined && model[i].FieldValue !== '') {
                                this.enrollmentViewModel.MEDB = moment(model[i].FieldValue).format('MM/DD/YYYY')
                            } else {
                                this.enrollmentViewModel.MEDB = null
                            }
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.APPDOB) {
                            this.enrollmentViewModel.APPDOB = moment(model[i].FieldValue).format('MM/DD/YYYY')
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.APPPHONE) {
                            this.enrollmentViewModel.APPPHONE = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.APPGEN) {
                            if (model[i].FieldValue === 'M') {
                                this.enrollmentViewModel.APPGEN = 'M'
                            } else {
                                this.enrollmentViewModel.APPGEN = 'F'
                            }
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.CELLPHONE) {
                            this.enrollmentViewModel.CELLPHONE = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.APPEMAIL) {
                            this.enrollmentViewModel.APPEMAIL = model[i].FieldValue

                            //this.enrollmentViewModel.EOB=
                        }

                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.APPADD1) {
                            this.enrollmentViewModel.APPADD1 = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.APPADD2) {
                            this.enrollmentViewModel.APPADD2 = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.APPCITY) {
                            this.enrollmentViewModel.APPCITY = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.APPZIP) {
                            this.enrollmentViewModel.APPZIP = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.APPST) {
                            this.enrollmentViewModel.APPST = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.LTCFACILITY) {
                            this.enrollmentViewModel.LTCFACILITY = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.LTCPHONE) {
                            this.enrollmentViewModel.LTCPHONE = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.NOTES) {
                            this.enrollmentViewModel.NOTES = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.SEPREASONCD) {
                            this.enrollmentViewModel.SEPREASONCD = Number(model[i].FieldValue)
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.ELECTION) {
                            this.enrollmentViewModel.ELECTION = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.MAILADD1) {
                            this.enrollmentViewModel.MAILADD1 = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.MAILADD2) {
                            this.enrollmentViewModel.MAILADD2 = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.MAILCITY) {
                            this.enrollmentViewModel.MAILCITY = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.MAILST) {
                            this.enrollmentViewModel.MAILST = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.MAILZIP) {
                            this.enrollmentViewModel.MAILZIP = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.PWO) {
                            this.enrollmentViewModel.PWO = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.AGENTID) {
                            this.enrollmentViewModel.AGENTID = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.PLANYEAR) {
                            this.enrollmentViewModel.PLANYEAR = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.LANG) {
                            this.enrollmentViewModel.LANG = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.OTHCVRG) {
                            this.enrollmentViewModel.OTHCVRG = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.LANGFORMAT) {
                            this.enrollmentViewModel.EOB = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.ACCOUNTNB) {
                            this.enrollmentViewModel.ACCOUNTNB = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.OTHCVRGNAME) {
                            this.enrollmentViewModel.OTHCVRGNAME = model[i].FieldValue
                        }

                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.OTHCVRGID) {
                            this.enrollmentViewModel.OTHCVRGID = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.OTHCVRGGRP) {
                            this.enrollmentViewModel.OTHCVRGGRP = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.COBBIN) {
                            this.enrollmentViewModel.COBBIN = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.COBPCN) {
                            this.enrollmentViewModel.COBPCN = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.COBEFFDT) {
                            if (model[i].FieldValue !== undefined && model[i].FieldValue !== '') {
                                this.enrollmentViewModel.COBEFFDT = moment(model[i].FieldValue).format('MM/DD/YYYY')
                            } else {
                                this.enrollmentViewModel.COBEFFDT = null
                            }
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.COBTERMDT) {
                            if (model[i].FieldValue !== undefined && model[i].FieldValue !== '') {
                                this.enrollmentViewModel.COBTERMDT = moment(model[i].FieldValue).format('MM/DD/YYYY')
                            } else {
                                this.enrollmentViewModel.COBTERMDT = null
                            }
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.FININSTNAME) {
                            this.enrollmentViewModel.FININSTNAME = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.EFTTYPE) {
                            this.enrollmentViewModel.EFTTYPE = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.ROUTINGNB) {
                            this.enrollmentViewModel.ROUTINGNB = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.SEPEFFDT) {
                            if (model[i].FieldValue !== undefined && model[i].FieldValue !== '') {
                                this.enrollmentViewModel.SEPEFFDT = moment(model[i].FieldValue).format('MM/DD/YYYY')
                            } else {
                                this.enrollmentViewModel.SEPEFFDT = null
                            }
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.BENEFICIARYDATE) {
                            this.enrollmentViewModel.BENEFICIARYDATE = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.AUTHREPIND) {
                            this.enrollmentViewModel.AUTHREPIND = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.AUTHREPNAME) {
                            this.enrollmentViewModel.AUTHREPNAME = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.AUTHREPPHONE) {
                            this.enrollmentViewModel.AUTHREPPHONE = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.AUTHREPREL) {
                            this.enrollmentViewModel.AUTHREPREL = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.AUTHREPADD1) {
                            this.enrollmentViewModel.AUTHREPADD1 = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.AUTHREPCITY) {
                            this.enrollmentViewModel.AUTHREPCITY = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.AUTHREPST) {
                            this.enrollmentViewModel.AUTHREPST = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.AUTHREPZIP) {
                            this.enrollmentViewModel.AUTHREPZIP = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.AUTHREPADD2) {
                            this.enrollmentViewModel.AUTHREPADD2 = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.AUTHREPCOPYIND) {
                            this.enrollmentViewModel.AUTHREPCOPYIND = model[i].FieldValue
                        }

                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.SOA) {
                            this.enrollmentViewModel.SOA = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.PLANNAME) {
                            this.enrollmentViewModel.PLANNAME = model[i].FieldValue
                        }

                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.CUID) {
                            this.enrollmentViewModel.CUID = model[i].FieldValue
                        }

                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.CURRENTGENDER) {
                            this.enrollmentViewModel.CURRENTGENDER = model[i].FieldValue
                            if (this.enrollmentViewModel.CURRENTGENDER == '4') {
                                // this.iscurrentGenderOther = true;
                            }
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.CURRENTGENDEROTH) {
                            this.enrollmentViewModel.CURRENTGENDEROTH = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.GENDERNPRONOUN) {
                            this.enrollmentViewModel.GENDERNPRONOUN = model[i].FieldValue
                            if (this.enrollmentViewModel.GENDERNPRONOUN == '4') {
                                //this.isyourSelfOther = true;
                            }
                        }

                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.GENDERNPRONOUNOTH) {
                            this.enrollmentViewModel.GENDERNPRONOUNOTH = model[i].FieldValue
                        }

                        if (model[i].FieldCode === EnrollmentFieldCodes.INDREPNAME) {
                            this.enrollmentViewModel.INDREPNAME = model[i].FieldValue
                        }

                        if (model[i].FieldCode === EnrollmentFieldCodes.RELTOENROLL) {
                            this.enrollmentViewModel.RELTOENROLL = model[i].FieldValue
                        }

                        if (model[i].FieldCode === EnrollmentFieldCodes.NPN) {
                            this.enrollmentViewModel.NPN = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodes.INDREPIND) {
                            this.enrollmentViewModel.INDREPIND = model[i].FieldValue
                        }
                    }

                    this.enrollmentViewModel.STEEREDIND = true
                    this.enrollmentViewModel.AGENTORGID = model[0].OrgID
                    if (this.enrollmentViewModel.PLANYEAR != undefined && this.enrollmentViewModel.PLANYEAR != '') {
                        this.setOrgname(this.enrollmentViewModel.PLANYEAR)
                    }

                    this.enrollmentViewModel.INSURANCECOMPID = model[0].InsuranceCoId
                    this.enrollmentViewModel.AGENTNAME = this.enrollmentViewModel.AGENTFN + ' ' + this.enrollmentViewModel.AGENTLN
                    this._enrollmentGateway
                        .GetAllStatesForBeneficiary(this.enrollmentViewModel.INSURANCECOMPID)
                        .subscribe((states: ValidatedSelectOptionModel[]) => {
                            this.states = states
                            this.loading = false
                            this.getElectionPeriod(model[0].OrgID, this.enrollmentViewModel.PLANYEAR, model[0].InsuranceCoId)
                        })

                    // this.enrollmentViewModel.AgentSignature = this.enrollmentViewModel.AgentSignature
                },
                (err) => {
                    this.loading = false
                }
            )
        }
    }

    getElectionPeriod(orgId: number, planYear: string, InsuranceCo: number) {
        this._enrollmentGateway.getElectionPeriods(InsuranceCo, planYear).subscribe((model: BeneficiaryElectionPeriods[]) => {
            //  this.getElectionPeriods(model)
            //this.setData()

            this._enrollmentGateway.getEnrollmentElectionTypes(InsuranceCo.toString(), planYear).subscribe((model) => {
                this.enrollmentElectionTypes = model
                // this.electionPeriodChanged(this.enrollmentViewModel.ELECTION)
                this.selectedElectionTypes = this.enrollmentElectionTypes.filter(
                    (electionType) => electionType.ElectionTypeName === this.enrollmentViewModel.ELECTION
                )
                this.reasonCode = this.enrollmentViewModel.SEPREASONCD.toString()
                this.electionOptionChanged(this.reasonCode)
                // this.loadPlanList(orgId)
            })
        })
    }
    electionOptionChanged(option: string) {
        if (option === '-1' || option === undefined) {
            return
        }

        let electionTypes = this.selectedElectionTypes.filter((electionType) => electionType.ElectionTypeID === parseInt(option))
        this.enrollmentViewModel.SELREASONCODE = electionTypes[0].ElectionTypeReasonCode
        this._enrollmentGateway.setEnrollmentViewModel(this.enrollmentViewModel)
    }
    resetAutorize() {
        if (this.enrollmentViewModel.AUTHREPIND !== 'Yes') {
            this.enrollmentViewModel.AUTHREPNAME = ''
            this.enrollmentViewModel.AUTHREPPHONE = ''
            this.enrollmentViewModel.AUTHREPADD1 = ''
            this.enrollmentViewModel.AUTHREPADD2 = ''
            this.enrollmentViewModel.AUTHREPCITY = ''
            this.enrollmentViewModel.AUTHREPREL = ''
            this.enrollmentViewModel.AUTHREPZIP = ''
            this.enrollmentViewModel.AUTHREPST = ''
            this.enrollmentViewModel.AUTHREPCOPYIND = ''
        }
    }
    setOrgname(planyear: string) {
        if (Number(planyear) === this._global.CurrentYear) {
            this.orgName = 'SilverScript'
        } else {
            this.orgName = 'Aetna'
        }
    }

    rblAppIndINDClick(event: any): void {
        if (event === 'Yes') {
            this.isAppInd = true
        } else {
            this.isAppInd = false
            this.enrollmentViewModel.RELTOENROLL = ''
            this.enrollmentViewModel.displayRELTOENROLL = ''
            this.enrollmentViewModel.NPN = ''
            this.enrollmentViewModel.INDREPNAME = ''
        }
        this.enrollmentViewModel.INDREPIND = event
    }
    isNPNmandatory: boolean = false
    relToEnrollonValueChange(value: any): void {
        this.enrollmentViewModel.RELTOENROLL = value
        this.relationshipToEnrolleeList.forEach((element, index) => {
            if (element.RelationshipToEnrolleeCode == Number(value)) {
                this.enrollmentViewModel.displayRELTOENROLL = element.RelationshipToEnrolleeValue
            }
        })

        if (this.enrollmentViewModel.displayRELTOENROLL == 'Agent' || this.enrollmentViewModel.displayRELTOENROLL == 'Broker') {
            this.isNPNmandatory = true
        } else {
            this.isNPNmandatory = false
        }
    }
}
